module.exports = __webpack_public_path__ + "e903324b069193938da00b6ba135431c.svg";